export default __webpack_public_path__ + "static/media/home-header.a9f1835e.jpg";